import React from 'react';
import { detector } from '../../lib/util/Detect';
import './index.scss';

const storageKey = 'show_recycle_tip';

class TopTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowModal: false,
      isShowTip: false,
    };
    this.preventDefault = this.preventDefault.bind(this);
  }

  componentDidMount() {
    const storageValue = window.localStorage.getItem(storageKey);
    if (!storageValue || Number(storageValue) < 3) {
      this.setState({ isShowTip: true });
      window.localStorage.setItem(storageKey, Number(storageValue) + 1);
    }
  }

  preventDefault(event) {
    event.preventDefault();
  }

  showTipModal() {
    this.setState({ isShowModal: true });
  }

  hideTipModal() {
    this.setState({ isShowModal: false, isShowTip: false });
    // 直接设置已经达到次数限制
    window.localStorage.setItem(storageKey, 3);
  }

  renderTipModal() {
    const bottom = detector.os.android ? 80 : 8;
    console.log(bottom, 'bottom');
    return (
        <div className={`tip-modal-mask ${this.state.isShowModal ? 'show' : ''}`}>
            <div className="tip-modal" style={{ bottom }}>
                <div className="tip-modal-title">账户规则调整</div>
                <div className="tip-modal-desc">
                  <p style={{ textIndent: '2em' }}>若您的账户连续30日未登录QQ浏览器福利中心，此前发放的奖励将过期。自2021年4月23日起，平台将开始对超过30天未登录福利中心的用户账号内的奖励进行清零处理。</p>
                </div>
                <div className="tip-modal-btn" onClick={this.hideTipModal.bind(this)}><span>知道了</span></div>
            </div>
        </div>
    );
  }

  render() {
    return (
        <div className="toptip-comp">
            {this.state.isShowTip && (
              <div className="toptip-wrap" onClick={this.showTipModal.bind(this)}>
                <div className="toptip-desc">福利中心账户规则调整</div>
              </div>
            )}
            {this.renderTipModal()}
        </div>
    );
  }
}

export default TopTip;
